import React, { useState, useEffect, useContext, useRef } from "react";
import CardFullView from "./CardFullView/CardFullView";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { UserContext } from "../login/LoginForm";
import { AuthContext } from "../login/AuthContext";
import { getItem } from "../../utils/localStorage";
import Select from "react-select";
import GridViewMain from "./GridViewMain";
import ConfirmationModal from "./ConfirmationModal";
import FilterComponent from "./FilterComponent";
import NameSelect from "./NameSelect";
import MoreOptionsButton from "../UsefulComponent/moreOptionButtonSingle";
import CheckOptions from "../UsefulComponent/checkOptions";
import EditOptionButton from "../UsefulComponent/editOptionButton";
import { teams } from "../CreateCardForm/teamslist";
// import css CardGrid2
import cardDesign from "../UsefulComponent/cardDesign";
import PaginationComponent from "./PaginationComponent";
import SortingSelect from "./SortingSelect";
import axios from "axios";
function CardGrid({ setCards, cards, groupedCards, viewAsGrid, viewOnly }) {
  const [isFilterVisible, setIsFilterVisible] = useState(true);
  const [showMore, setShowMore] = useState(false); // State for showing additional filter content
  //style={{border: "2px solid black",   padding: "10px",
  const hasEffectRunRef = useRef(false);
  const navigate = useNavigate();
  const [selectedAction1, setSelectedAction1] = useState("");
  const [collections, setCollections] = useState([]); // State to hold the collections array
  const [selectedCollection, setSelectedCollection] = useState("");
  const [selectedCollectionLive, setSelectedCollectionLive] = useState("");
  const [selectedCollectionTitle, setSelectedCollectionTitle] = useState("");
  const [isViewCollection, setIsViewCollection] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedCards, setSelectedCards] = useState([]);
  const [allCollectionCards, setAllCollectionCards] = useState([]);
  const [recentlyDeletedCards, setRecentlyDeletedCards] = useState([]);
  const [isViewRecentlyDeleted, setIsViewRecentlyDeleted] = useState(false);
  const [selectedCollectionCards, setSelectedCollectionCards] = useState([]);
  const [tempoCards, setTempoCards] = useState([]);
  const [multiEditState, setMultiEditState] = useState(false);
  const [filterValues, setFilterValues] = useState({});
  // isGone: {0: true}
  const [filteredCards, setFilteredCards] = useState([]);
  const [nameCounts, setNameCounts] = useState({});
  const [teamsIdCounts, setTeamsIdCounts] = useState({});
  const [setCounts, setSetCounts] = useState({});
  const [variationNameCounts, setVariationNameCounts] = useState({});
  const [cardNameCounts, setCardNameCounts] = useState({});
  const [yearCounts, setYearCounts] = useState({});
  const [isRookieCounts, setIsRookieCounts] = useState({});
  const [isPatchCounts, setIsPatchCounts] = useState({});
  const [isJerseyCounts, setIsJerseyCounts] = useState({});
  const [isAutoCounts, setIsAutoCounts] = useState({});
  const [isForSaleCounts, setIsForSaleCounts] = useState({});
  const [isForTradeCounts, setIsForTradeCounts] = useState({});
  const [isOnEbayCounts, setIsOnEbayCounts] = useState({});
  const [isPCCounts, setIsPCCounts] = useState({});
  const [isGoneCounts, setIsGoneCounts] = useState({});
  const [isGradedCounts, setIsGradedCounts] = useState({});
  const [gradeCompanyCounts, setGradeCompanyCounts] = useState({});
  const [gradeCounts, setGradeCounts] = useState({});
  const [selectedCollectionInnerText, setSelectedCollectionInnerText] =
    useState({});
  const [
    confirmationVisibleForDeleteFromCollectionOnly,
    setConfirmationVisibleForDeleteFromCollectionOnly,
  ] = useState(false);
  const [
    confirmationVisibleForDeleteCards,
    setConfirmationVisibleForDeleteCards,
  ] = useState(false);
  const [
    confirmationVisibleCreateNewCollection,
    setConfirmationVisibleCreateNewCollection,
  ] = useState(false);
  const [createNewCollectionTitle, setCreateNewCollectionTitle] = useState("");
  const [
    confirmationVisibleDeleteCollection,
    setConfirmationVisibleDeleteCollection,
  ] = useState(false);
  const [
    confirmationVisibleRenameWatchList,
    setConfirmationVisibleRenameWatchList,
  ] = useState(false);
  const [renameCollectionTitle, setRenameCollectionTitle] = useState("");
  const [userResponse, setUserResponse] = useState(false);
  const [needToReset, setNeedToReset] = useState(false);
  const [isPcUpdate, setIsPcUpdate] = useState(false);
  const [isForSaleUpdate, setIsForSaleUpdate] = useState(false);
  const [isForTradeUpdate, setIsForTradeUpdate] = useState(false);
  const [isOnEbayUpdate, setIsOnEbayUpdate] = useState(false);
  const initialIsGoneChecked = {
    0: true, // Default value for "No"
    1: false, // Default value for "Yes"
  };
  const [isGoneChecked, setIsGoneChecked] = useState({});
  
  const { userId} = useContext(AuthContext);
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [totalCardValue, setTotalCardValue] = useState(0);
  const [totalCardLenght, setTotalCardLenght] = useState(0);
  const [searchBarSelectName, setSearchBarSelectName] = useState("");
  const [checkedCheckboxes, setCheckedCheckboxes] = useState({});
  const [singleCardOperationId, setSingleCardOperationId] = useState(0);
  const [attributeFilterLogic, setAttributeFilterLogic] = useState("Or"); // Default to "Or"
  const [isWhatFilterLogic, setIsWhatFilterLogic] = useState("Or");

  const [filteredGroupedCards, setFilteredGroupedCards] = useState([]);

  // Inside your component
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);

  const lastItemIndex = currentPage * itemsPerPage;
  const firstItemIndex = lastItemIndex - itemsPerPage;
  const currentItems = filteredCards.slice(firstItemIndex, lastItemIndex);

  const totalPages = Math.ceil(filteredCards.length / itemsPerPage);

 
  
  const totalPagesGrouped = Math.ceil(filteredGroupedCards.size / itemsPerPage);
 // const [currentItemsGrouped, setCurrentItemsGrouped] = filteredGroupedCards.slice(firstItemIndex, lastItemIndex);
  const currentItemsGrouped=Array.from(filteredGroupedCards.values()).slice(firstItemIndex, lastItemIndex);
  
  console.log('GROUPED DETAILS  filteredGroupedCards',filteredGroupedCards,'totalPagesGrouped',totalPagesGrouped,'currentItemsGrouped',currentItemsGrouped)

  useEffect(() => {
  console.log('currentItemsGrouped',currentItemsGrouped)
   
  }, [currentItemsGrouped]);


  const [sortValue, setSortValue] = useState("");
  const [searchTermInput, setSearchTermInput] = useState("");
  const [activeSearchTerm, setActiveSearchTerm] = useState("");
  const [originalData, setOriginalData] = useState([]);
  const [triggerFilterChange, setTriggerFilterChange] = useState(false);
  const [viewImageOnly, setViewImageOnly] = useState(false);
  const [viewPrice, setViewPrice] = useState(false);
  const [isEditingPriceVisible, setIsEditingPriceVisible] = useState(false);






  //const [bringBackOriginal,setBringBackOriginal]=useState(false)
  const PriceEditChange = ({ card, onPriceUpdate }) => {
    // State for each individual card
    console.log("card id", card);

    const [isEditingPrice, setIsEditingPrice] = useState(true);
    const [editableValue, setEditableValue] = useState(
      card.EstimateValue ? card.EstimateValue : -1
    );
    const [editableTV, setEditableTV] = useState(
      card.tradeValue ? card.tradeValue : -1
    );
    const [editableSalePrice, setEditableSalePrice] = useState(
      card.Price ? card.Price : -1
    );
    const [editableOffer, setEditableOffer] = useState(card.BestOffer === 1);

    const [currentUsercardId, setCurrentUsercardId] = useState(card.id);

    // State to track the original data
    const [originalData, setOriginalData] = useState({
      EstimateValue: card.EstimateValue,
      Price: card.Price,
      tradeValue: card.tradeValue,
      BestOffer: card.BestOffer === 1,
    });



    console.log("here is groupedCards", groupedCards);


    const handleEditClick = (event) => {
      event.stopPropagation();
      setIsEditingPrice(true);
    };

    const handleOfferChange = () => {
      setEditableOffer(!editableOffer);
    };

    const handleTVChange = (event) => {
      event.stopPropagation();
      const value = event.target.value;
      if (
        value === "" ||
        (!isNaN(value) && value.trim() !== "" && !/^0\d/.test(value))
      ) {
        setEditableTV(value);
      }
    };

    const handleTVBlur = () => {
      // Remove leading zeros and correct invalid formats
      let correctedValue = parseFloat(editableTV);
      // Check for NaN and set to a default or leave as is
      correctedValue = isNaN(correctedValue) ? 0 : correctedValue;
      setEditableTV(correctedValue);
    };
    const handleSalePriceChange = (event) => {
      event.stopPropagation();

      const value = event.target.value;
      if (
        value === "" ||
        (!isNaN(value) && value.trim() !== "" && !/^0\d/.test(value))
      ) {
        setEditableSalePrice(value);
      }
    };
    const handleSalePriceBlur = () => {
      // Remove leading zeros and correct invalid formats
      let correctedValue = parseFloat(editableSalePrice);
      // Check for NaN and set to a default or leave as is
      correctedValue = isNaN(correctedValue) ? 0 : correctedValue;
      setEditableSalePrice(correctedValue);
    };

    const handleValueChange = (event) => {
      event.stopPropagation();
      const value = event.target.value;
      // Allow empty string to clear the input, or check if it's a valid float number
      if (
        value === "" ||
        (!isNaN(value) && value.trim() !== "" && !/^0\d/.test(value))
      ) {
        setEditableValue(value);
      }
    };

    const handleValueBlur = () => {
      // Remove leading zeros and correct invalid formats
      let correctedValue = parseFloat(editableValue);
      // Check for NaN and set to a default or leave as is
      correctedValue = isNaN(correctedValue) ? 0 : correctedValue;
      setEditableValue(correctedValue);
    };

    const handleSaveClick = (event) => {
      event.stopPropagation();
      updateTables();
      console.log(
        "here is card.id",
        card.id,
        "currentcardid",
        currentUsercardId
      );
      onPriceUpdate(card.id, editableTV); // Call a function passed via props to update the price in the parent state or send it to the server
    };

    const updateEstimateValues = async (info) => {
      try {
        console.log("info updateEstimateValues", info);
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE}/api/estimateValue/update/value`,
          info
        );
        console.log("Updating estimateValue was a success", response.data);
      } catch (error) {
        console.error("Error Updating estimateValue", error);
      }
    };

    const insertIntoSellCards = async (info) => {
      try {
        console.log("info insertIntoSellCards", info);
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE}/api/price/insert/sellcards`,
          info
        );
        console.log("Insert into sellCards was a success", response.data);
      } catch (error) {
        console.error("Error Inserting sellCards", error);
      }
    };

    const updateForSaleStatus = async (info) => {
      try {
        console.log("info updateForSaleStatus", info);
        const response = await axios.post(
         `${process.env.REACT_APP_API_BASE}/api/forsale/update/true`,
          info
        );
        console.log("Updating forSale status was a success", response.data);
      } catch (error) {
        console.error("Error Updating forSale status", error);
      }
    };

    const updateSellCards = async (info) => {
      try {
        console.log("info updateSellCards", info);
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE}/api/price/update/price`,
          info
        );
        console.log("Updating price was a success", response.data);
      } catch (error) {
        console.error("Error Updating price", error);
      }
    };

    const insertIntoTradeCards = async (info) => {
      try {
        console.log("info insertIntoTradeCards", info);
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE}/api/tradevalue/insert/tradecards`,
          info
        );
        console.log("Insert into tradecards was a success", response.data);
      } catch (error) {
        console.error("Error Inserting tradecards", error);
      }
    };

    const updateForTradeStatus = async (info) => {
      try {
        console.log("info updateForTradeStatus", info);
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE}/api/fortrade/update/true`,
          info
        );
        console.log("Updating forTrade status was a success", response.data);
      } catch (error) {
        console.error("Error Updating forTrade status", error);
      }
    };

    const updateTradeCards = async (info) => {
      try {
        console.log("info updateTradeCards", info);
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE}/api/tradevalue/update/tradevalue`,
          info
        );
        console.log("Updating tradeValue was a success", response.data);
      } catch (error) {
        console.error("Error Updating tradeValue", error);
      }
    };

    const updateTables = async () => {
      const hasDataChanged = () => {
        return (
          originalData.EstimateValue !== editableValue ||
          originalData.Price !== editableSalePrice ||
          originalData.tradeValue !== editableTV ||
          originalData.BestOffer !== editableOffer
        );
      };

      if (hasDataChanged()) {
        try {
          console.log(
            "originalData EstimateValue",
            originalData.EstimateValue,
            "editableValue",
            editableValue
          );
          if (
            originalData.EstimateValue !== editableValue &&
            editableValue !== null &&
            editableValue !== -1
          ) {
            console.log("doing 305");
            await updateEstimateValues({
              UserId: userId,
              userCardId: currentUsercardId,
              EstimateValue: editableValue,
            });
          }
          console.log(
            "originalData Price",
            originalData.Price,
            "editableSalePrice",
            editableSalePrice
          );
          if (
            (originalData.Price !== editableSalePrice &&
              editableSalePrice !== null &&
              editableSalePrice !== -1) ||
            originalData.BestOffer != editableOffer
          ) {
            if (originalData.Price === null) {
              console.log("doing 315");
              await insertIntoSellCards({
                UserId: userId,
                userCardId: currentUsercardId,
                Price: editableSalePrice,
                BestOffer: editableOffer,
              });
              console.log("doing 320");
              await updateForSaleStatus({
                UserId: userId,
                userCardId: currentUsercardId,
                isForSale: true,
              });
            } else {
              console.log("doing 326");
              await updateSellCards({
                UserId: userId,
                userCardId: currentUsercardId,
                Price: editableSalePrice,
                BestOffer: editableOffer,
              });
            }
          }
          console.log(
            "originalData tradeValue",
            originalData.tradeValue,
            "editableTV",
            editableTV
          );
          if (
            originalData.tradeValue !== editableTV &&
            editableTV !== null &&
            editableTV !== -1
          ) {
            if (originalData.tradeValue === null) {
              console.log("doing 336");
              await insertIntoTradeCards({
                UserId: userId,
                userCardId: currentUsercardId,
                tradeValue: editableTV,
              });
              console.log("doing 341");
              await updateForTradeStatus({
                UserId: userId,
                userCardId: currentUsercardId,
                isForTrade: true,
              });
            } else {
              console.log("doing 347");
              await updateTradeCards({
                UserId: userId,
                userCardId: currentUsercardId,
                tradeValue: editableTV,
              });
            }
          }

          // Set the new originalData after all updates
          setOriginalData({
            EstimateValue: editableValue,
            Price: editableSalePrice,
            tradeValue: editableTV,
          });
        } catch (error) {
          console.error("Failed to update card data:", error);
          // Handle error (e.g., show error message to the user)
        }
      } else {
        console.log("No changes to save");
      }
    };

    return (
      <div className="card-value" onClick={(event) => event.stopPropagation()}>
        {isEditingPrice ? (
          <>
            <div className="flex-h" style={{ gap: "7px" }}>
              {editableValue >= -1 && (
                <>
                  <div className="nappa">
                    <div>
                      <h4 style={{ textDecoration: "underline" }}>Value</h4>
                    </div>
                    <input
                      type="text"
                      //style={{ textAlign: "center" }}
                      value={editableValue < 0 ? null : editableValue}
                      placeholder={editableValue < 0 ? "N/A" : ""}
                      onChange={handleValueChange}
                      onBlur={handleValueBlur}
                    />
                  </div>
                </>
              )}

              {editableTV >= -1 ? (
                <>
                  <div className="nappa">
                    <div>
                      <h4 style={{ textDecoration: "underline" }}>Trade(TV)</h4>
                    </div>

                    <input
                      type="text"
                      // style={{ textAlign: "center" }}
                      value={editableTV < 0 ? null : editableTV}
                      placeholder={editableTV < 0 ? "N/A" : ""}
                      onChange={handleTVChange}
                      onBlur={handleTVBlur}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div></div>
                </>
              )}
            </div>

            {editableSalePrice >= -1 && (
              <>
                <div className="nappa">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h4
                      style={{
                        textDecoration: "underline",
                      }}
                    >
                      ForSale Price
                    </h4>

                    <h4 style={{ textDecoration: "underline" }}>Offer?</h4>
                  </div>
                  <div className="wasd">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <input
                        type="text"
                        // style={{ textAlign: "center" }}
                        value={editableSalePrice < 0 ? null : editableSalePrice}
                        placeholder={editableSalePrice < 0 ? "N/A" : ""}
                        onChange={handleSalePriceChange}
                        onBlur={handleSalePriceBlur}
                        style={{ minWidth: "75%" }}
                      />
                      <input
                        type="checkbox"
                        style={{ cursor: "pointer", transform: "scale(0.4)" }}
                        checked={editableOffer}
                        onChange={handleOfferChange}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        paddingLeft: "3px",
                      }}
                    >
                      <h4>
                        +
                        {card.Shipping === 0 || card.Shipping === null
                          ? "Free"
                          : card.Shipping.toFixed(2)}
                      </h4>
                      <lable style={{ fontSize: "14px" }}>(Shipping)</lable>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button onClick={handleSaveClick}>Save</button>
            </div>
          </>
        ) : (
          <>
            <button onClick={() => handleEditClick}>Edit</button>
          </>
        )}
      </div>
    );
  };

  const handlePriceUpdate = (cardId, newPrice) => {
    // Update the card price in the parent state and optionally sync with the backend
    // const updatedCards = cards.map((card) =>
    //   card.id === cardId ? { ...card, estimateValue: newPrice } : card
    // );
    // setCards(updatedCards);

    console.log("outside priceupdate", cardId, newPrice);
    // Additionally, you can make an API call here to update the backend
  };

 

  const iconViewImageOnly = () => {
    const handleClickIcon = () => {
      setViewImageOnly(!viewImageOnly);
      setViewPrice(false);
    };

    const eyeOpenIcon = () => {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          fill="none"
          stroke="#fcfcfc"
          viewBox="0 0 24 24"
        >
          <g
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>{" "}
            <path d="M12.001 5C7.524 5 3.733 7.943 2.46 12c1.274 4.057 5.065 7 9.542 7 4.478 0 8.268-2.943 9.542-7-1.274-4.057-5.064-7-9.542-7z"></path>
          </g>
        </svg>
      );
    };
    const eyeClosedIcon = () => {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="#ffffff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M2.999 3l18 18M9.843 9.914a3 3 0 004.265 4.22M6.5 6.646A10.024 10.024 0 002.457 12c1.274 4.057 5.065 7 9.542 7 1.99 0 3.842-.58 5.4-1.582m-6.4-12.369c.329-.032.663-.049 1-.049 4.478 0 8.268 2.943 9.542 7a9.954 9.954 0 01-1.189 2.5"
          ></path>
        </svg>
      );
    };

    return (
      <div onClick={() => handleClickIcon()}>
        {viewImageOnly ? eyeClosedIcon() : eyeOpenIcon()}
      </div>
    );
  };

  const iconViewPrice = () => {
    const handleClickIcon = () => {
      setViewPrice(!viewPrice);
    };

    const priceOpenIcon = () => {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="45"
          height="45"
          fill="#fff"
          stroke="#fff"
          strokeWidth="3.072"
          version="1.1"
          viewBox="-128 -128 768 768"
          xmlSpace="preserve"
        >
          <rect
            width="45"
            height="45"
            x="-128"
            y="-128"
            fill="#fafafa"
            strokeWidth="0"
            rx="384"
          ></rect>
          <g>
            <path
              fill="#FFF"
              d="M192.707 496.493L17.773 321.56a21.633 21.633 0 010-30.72L265.24 41.667h198.827v207.36l-240.64 247.467c-8.534 7.679-22.187 7.679-30.72-.001h0z"
              transform="translate(1 1)"
            ></path>
            <g fill="#080808">
              <path
                d="M208.067 511c-7.68 0-15.36-3.413-21.333-8.533L11.8 327.533C5.827 321.56 3.267 313.88 3.267 306.2s3.413-15.36 8.533-21.333L261.827 33.133H472.6V252.44L229.4 502.467c-5.973 5.12-13.653 8.533-21.333 8.533zm60.586-460.8L24.6 296.813c-2.56 2.56-4.267 5.973-4.267 9.387 0 3.413 1.707 6.827 3.413 9.387L198.68 490.52c5.12 5.12 13.653 5.12 18.773 0l238.08-244.907V50.2h-186.88z"
                transform="translate(1 1)"
              ></path>
              <path
                d="M202.093 385.56c-17.067 0-34.133-5.973-47.787-17.067l-9.387 9.387c-3.413 3.413-8.533 3.413-11.947 0-3.413-3.413-3.413-8.533 0-11.947l9.387-9.387c-23.893-29.867-22.187-74.24 5.973-102.4 3.413-3.413 8.533-3.413 11.947 0 3.413 3.413 3.413 8.533 0 11.947-21.333 21.333-23.04 54.613-5.973 77.653l76.8-76.8-6.827-52.053c-1.707-14.507 2.56-29.013 11.093-40.107 8.533-11.093 21.333-17.92 34.987-18.773 19.627-1.707 39.253 4.267 54.613 16.213l5.973-5.973c3.413-3.413 8.533-3.413 11.947 0 3.413 3.413 3.413 8.533 0 11.947l-5.973 5.973c23.893 29.867 22.187 74.24-5.973 102.4-3.413 3.413-8.533 3.413-11.947 0-3.413-3.413-3.413-8.533 0-11.947 21.333-21.333 23.04-54.613 5.973-77.653l-76.8 76.8L255 325.827c1.707 14.507-2.56 29.013-11.947 40.107-8.533 11.093-21.333 17.92-34.987 18.773-1.706.853-3.413.853-5.973.853zm-35.84-29.013c11.947 8.533 26.453 12.8 40.96 11.947 9.387-.853 17.067-5.12 23.04-12.8 5.973-7.68 9.387-17.92 7.68-27.307l-4.267-39.253-67.413 67.413zm110.934-182.614h-5.12c-9.387.853-17.067 5.12-23.04 12.8-5.973 7.68-9.387 17.92-7.68 27.307l5.12 38.4 67.413-67.413c-11.093-6.827-23.04-11.094-36.693-11.094z"
                transform="translate(1 1)"
              ></path>
            </g>
            <path
              fill="#050505"
              d="M412.867 127c0 18.773-15.36 34.133-34.133 34.133S344.6 145.773 344.6 127s15.36-34.133 34.133-34.133 34.134 15.36 34.134 34.133h0z"
              transform="translate(1 1)"
            ></path>
            <g fill="#080808">
              <path
                d="M378.733 169.667c-23.893 0-42.667-18.773-42.667-42.667s18.773-42.667 42.667-42.667c23.893 0 42.667 18.773 42.667 42.667s-18.773 42.667-42.667 42.667zm0-68.267c-14.507 0-25.6 11.093-25.6 25.6s11.093 25.6 25.6 25.6c14.507 0 25.6-11.093 25.6-25.6s-11.093-25.6-25.6-25.6z"
                transform="translate(1 1)"
              ></path>
              <path
                d="M378.733 135.533c-2.56 0-4.267-.853-5.973-2.56-3.413-3.413-3.413-8.533 0-11.947L492.227 1.56c3.413-3.413 8.533-3.413 11.947 0 3.413 3.413 3.413 8.533 0 11.947L384.707 132.973c-1.707 1.707-3.414 2.56-5.974 2.56z"
                transform="translate(1 1)"
              ></path>
            </g>
          </g>
        </svg>
      );
    };
    const priceClosedIcon = () => {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="45"
          height="45"
          fill="#fff"
          stroke="#fff"
          strokeWidth="13.824"
          version="1.1"
          viewBox="-122.88 -122.88 757.76 757.76"
          xmlSpace="preserve"
        >
          <rect
            width="45"
            height="45"
            x="-122.88"
            y="-122.88"
            fill="#fafafa"
            strokeWidth="0"
            rx="378.88"
          ></rect>
          <g>
            <path
              fill="#FFF"
              d="M192.707 496.493L17.773 321.56a21.633 21.633 0 010-30.72L265.24 41.667h198.827v207.36l-240.64 247.467c-8.534 7.679-22.187 7.679-30.72-.001h0z"
              transform="translate(1 1)"
            ></path>
            <g fill="#8a0505">
              <path
                d="M208.067 511c-7.68 0-15.36-3.413-21.333-8.533L11.8 327.533C5.827 321.56 3.267 313.88 3.267 306.2s3.413-15.36 8.533-21.333L261.827 33.133H472.6V252.44L229.4 502.467c-5.973 5.12-13.653 8.533-21.333 8.533zm60.586-460.8L24.6 296.813c-2.56 2.56-4.267 5.973-4.267 9.387 0 3.413 1.707 6.827 3.413 9.387L198.68 490.52c5.12 5.12 13.653 5.12 18.773 0l238.08-244.907V50.2h-186.88z"
                transform="translate(1 1)"
              ></path>
              <path
                d="M202.093 385.56c-17.067 0-34.133-5.973-47.787-17.067l-9.387 9.387c-3.413 3.413-8.533 3.413-11.947 0-3.413-3.413-3.413-8.533 0-11.947l9.387-9.387c-23.893-29.867-22.187-74.24 5.973-102.4 3.413-3.413 8.533-3.413 11.947 0 3.413 3.413 3.413 8.533 0 11.947-21.333 21.333-23.04 54.613-5.973 77.653l76.8-76.8-6.827-52.053c-1.707-14.507 2.56-29.013 11.093-40.107 8.533-11.093 21.333-17.92 34.987-18.773 19.627-1.707 39.253 4.267 54.613 16.213l5.973-5.973c3.413-3.413 8.533-3.413 11.947 0 3.413 3.413 3.413 8.533 0 11.947l-5.973 5.973c23.893 29.867 22.187 74.24-5.973 102.4-3.413 3.413-8.533 3.413-11.947 0-3.413-3.413-3.413-8.533 0-11.947 21.333-21.333 23.04-54.613 5.973-77.653l-76.8 76.8L255 325.827c1.707 14.507-2.56 29.013-11.947 40.107-8.533 11.093-21.333 17.92-34.987 18.773-1.706.853-3.413.853-5.973.853zm-35.84-29.013c11.947 8.533 26.453 12.8 40.96 11.947 9.387-.853 17.067-5.12 23.04-12.8 5.973-7.68 9.387-17.92 7.68-27.307l-4.267-39.253-67.413 67.413zm110.934-182.614h-5.12c-9.387.853-17.067 5.12-23.04 12.8-5.973 7.68-9.387 17.92-7.68 27.307l5.12 38.4 67.413-67.413c-11.093-6.827-23.04-11.094-36.693-11.094z"
                transform="translate(1 1)"
              ></path>
            </g>
            <path
              fill="#fcfcfc"
              d="M412.867 127c0 18.773-15.36 34.133-34.133 34.133S344.6 145.773 344.6 127s15.36-34.133 34.133-34.133 34.134 15.36 34.134 34.133h0z"
              transform="translate(1 1)"
            ></path>
            <g fill="#8a0505">
              <path
                d="M378.733 169.667c-23.893 0-42.667-18.773-42.667-42.667s18.773-42.667 42.667-42.667c23.893 0 42.667 18.773 42.667 42.667s-18.773 42.667-42.667 42.667zm0-68.267c-14.507 0-25.6 11.093-25.6 25.6s11.093 25.6 25.6 25.6c14.507 0 25.6-11.093 25.6-25.6s-11.093-25.6-25.6-25.6z"
                transform="translate(1 1)"
              ></path>
              <path
                d="M378.733 135.533c-2.56 0-4.267-.853-5.973-2.56-3.413-3.413-3.413-8.533 0-11.947L492.227 1.56c3.413-3.413 8.533-3.413 11.947 0 3.413 3.413 3.413 8.533 0 11.947L384.707 132.973c-1.707 1.707-3.414 2.56-5.974 2.56z"
                transform="translate(1 1)"
              ></path>
            </g>
          </g>
        </svg>
      );
    };

    return (
      <div onClick={() => handleClickIcon()}>
        {viewPrice ? priceOpenIcon() : priceClosedIcon()}
      </div>
    );
  };

  const handleChangePage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleChangeItemsPerPage = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1); // Reset to the first page when changing the number of items per page
  };

  const toggleFilter = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  //-----------------------------------------------FetchData(Get)---------------------------------------------------
  //----------------------Get Collections----------------------
  function fetchCollectionsCards() {
    // Perform the API call to get the collections
    // Replace 'apiEndpoint' with your actual API endpoint
    fetch(
      `${process.env.REACT_APP_API_BASE}/api/collection/getCollectionUserCards/${userId}`
    )
      .then((response) => response.json())
      .then((data) => {
        const formattedData = formatData(data);
        // Update the collections state with the data from the API response
        setAllCollectionCards(formattedData);
      })
      .catch((error) => {
        // Handle the error
        console.error("Error fetching collections:", error);
      });
  }
  const formatData = (data) => {
    return data.map((item) => ({
      userCardId: item.userCardId,
      ListId: item.ListId,
    }));
  };
  //----------------------Get CardsForUser----------------------
  function fetchCollections() {
    // Perform the API call to get the collections
    // Replace 'apiEndpoint' with your actual API endpoint
    fetch(`${process.env.REACT_APP_API_BASE}/api/collection/getCollectionUser/${userId}`)
      .then((response) => response.json())
      .then((data) => {
        // Update the collections state with the data from the API response
        setCollections(data);
      })
      .catch((error) => {
        // Handle the error
        console.error("Error fetching collections:", error);
      });
  }

  function fetchRecentlyDeletedCards() {
    fetch(`${process.env.REACT_APP_API_BASE}/api/card/getRecentlyDeletedCards/${userId}`)
      .then((response) => response.json())
      .then((data) => {
        // Update the collections state with the data from the API response

        setRecentlyDeletedCards(data);
      })
      .catch((error) => {
        // Handle the error
        console.error("Error fetching recently deleted cards:", error);
      });
  }
  //----------------------End Get Collections/User----------------------
  //----------------------UseEffectToAssign(Cards/Collections)-------------------
  useEffect(() => {
    // Make the API call to fetch the collections
    fetchCollections();
    fetchCollectionsCards();
    // fetchRecentlyDeletedCards();
    // console.log("recentlyDeletedCards", recentlyDeletedCards);
    console.log(allCollectionCards);
  }, []);

  useEffect(() => {
    // Check if the effect has already run
    if (!hasEffectRunRef.current) {
      // Perform your one-time setup or side effect here
      // ...
      setCheckedCheckboxes({ No: true });
      setFilterValues({ isGone: { No: true } });
      // Update the ref to indicate that the effect has run
      hasEffectRunRef.current = true;
    }
  }, []);

  useEffect(() => {
    console.log("isGoneChecked ", isGoneChecked);
    console.log("checkedCheckboxes", checkedCheckboxes);
  }, [isGoneChecked]);

  useEffect(() => {
    console.log("-------------", filterValues);
  }, [filterValues]);
  //----------------------End UseEffectToAssign(Cards/Collections)-------------------
  //-----------------------------------------------End Of FetchData(Get)---------------------------------------------------
  //-----------------------------------------------HandleSingleAction---------------------------------------------------

  //-----------------------------------------------End - HandleSingleAction---------------------------------------------------
  //-----------------------------------------------actionCreateNewCollection - Handle - FetchData(Post)/CreateCollectionThenAssign---------------------------------------------------
  function handleCreateNewCollection(isConfirmed) {
    console.log("Creating a collection and assigning to it");
    const collectionTitle = createNewCollectionTitle; // Replace with your input or dynamic value
    if (isConfirmed) {
      fetch("https://projet-collect-v1-production.up.railway.app/api/collection/add/collection", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId, collectionTitle }),
      })
        .then((response) => response.json())
        .then((data) => {
          const { listId } = data;
          console.log("Created list ID:", listId);
          console.log("Created list Title:", collectionTitle);
          insertIntoCardsCardsList(listId);
          fetchCollections();
          fetchCollectionsCards();
          setCreateNewCollectionTitle("");
          setSelectedAction1("");
        })
        .catch((error) => {
          console.error("Error creating list:", error);
        });
    }
  }

  function handleRenameCollection(isConfirmed) {
    console.log("renaming the collection with id:", selectedCollectionLive);
    const collectionTitle = renameCollectionTitle; // Replace with your input or dynamic value
    if (isConfirmed) {
      fetch("https://projet-collect-v1-production.up.railway.app/api/collection/rename/watchlist", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId,
          collectionTitle,
          selectedCollectionLive,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          const { watchlistId } = data;

          console.log("Renamed list", " Title:", collectionTitle);
          setRenameCollectionTitle("");
          setConfirmationVisibleRenameWatchList(false);
        })
        .catch((error) => {
          console.error("Error renaming list:", error);
        });
    }
  }
  //-----------------------------------------------FetchData(Post)/AddCardToCollection---------------------------------------------------
  // Function to insert into cards_cardslist table
  function insertIntoCardsCardsList(listId) {
    const requestData = {
      listId: listId,
      cardIds: selectedCards,
    };

    fetch("https://projet-collect-v1-production.up.railway.app/api/collection/add/card", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Card inserted into cards_cardslist table");
      })
      .catch((error) => {
        console.error("Error inserting card into cards_cardslist:", error);
      });
  }
  function insertSingleIntoCardsCardsList(listId, cardId) {
    const requestData = {
      listId: listId,
      cardIds: cardId,
    };

    fetch("https://projet-collect-v1-production.up.railway.app/api/collection/add/card", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Card inserted into cards_cardslist table");
      })
      .catch((error) => {
        console.error("Error inserting card into cards_cardslist:", error);
      });
  }
  //-----------------------------------------------FetchData(Delete)/CardFromCollection---------------------------------------------------
  // Function to delete from cards_cardslist table
  function removeFromCardsCardsList(confirmationIs) {
    let cardIds = [...selectedCards];
    if (singleCardOperationId !== 0) cardIds = [singleCardOperationId];

    const requestData = {
      listId: selectedCollectionLive,
      cardIds: cardIds,
    };
    // Handle user's response
    const handleUserResponse = (response) => {
      if (response) {
        fetch("https://projet-collect-v1-production.up.railway.app/api/collection/remove/card", {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Cards deleted from cards_cardslist table");
            setConfirmationVisibleForDeleteFromCollectionOnly(false);
            setSelectedCards([]);
            fetchCollectionsCards();
            fetchCollections();
            setNeedToReset(!needToReset);
            setSingleCardOperationId(0);
          })
          .catch((error) => {
            console.error("Error deleting cards from cards_cardslist:", error);
            setConfirmationVisibleForDeleteFromCollectionOnly(false);
          });
      } else {
        console.log("Delete operation canceled by the user");
        setConfirmationVisibleForDeleteFromCollectionOnly(false);
      }
    };
    // Handle user's response based on the confirmationIs value
    handleUserResponse(confirmationIs);
  }

  //-----------------------------------------------FetchData(Put)/UpdateCardsStatus---------------------------------------------------
  function updateStatusForCards(confirmationToUpdateStatus) {
    const requestData = {
      userId: userId,
      cardIds: selectedCards,
      isPcUpdate: isPcUpdate,
      isForSaleUpdate: isForSaleUpdate,
      isForTradeUpdate: isForTradeUpdate,
      isOnEbayUpdate: isOnEbayUpdate,
    };

    fetch("https://projet-collect-v1-production.up.railway.app/api/collection/update/status", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Status updated for cards");
        // Handle the response data if needed
      })
      .catch((error) => {
        console.error("Error updating status for cards:", error);
      });
  }

  //-----------------------------------------------Filters---------------------------------------------------
  useEffect(() => {
    // Determine which filters are active based on filterValues
    const filterBy = Object.entries(filterValues).filter(([key, value]) => {
      if (key != "SearchBar") {
        if (key === "minPrice" || key === "maxPrice") {
          return value !== "";
        }
        const checkedValues = Object.entries(value)
          .filter(([_, v]) => v)
          .map(([k]) => k);
        return checkedValues.length > 0;
      }
    });

    // Enhance cards with match count based on the search term
    const cardsWithMatchCount = cards.map((card) => {
      let score = 0;
      if (activeSearchTerm && card.SearchTitle) {
        const keywords = activeSearchTerm.split(" ").filter(Boolean);
        const parts = card.SearchTitle.split(" - ");
        const playerName = parts[0].toLowerCase();
        const yearAndSet = parts.length > 1 ? parts[1].toLowerCase() : "";
        const year = yearAndSet.split(" ")[0];
        const cardName = parts.length > 2 ? parts[2].toLowerCase() : "";
        const variation = parts.length > 3 ? parts[3].toLowerCase() : "";
        const numberBehind = parts.length > 4 ? parts[4].toLowerCase() : "";

        keywords.forEach((keyword) => {
          const lowerCaseKeyword = keyword.toLowerCase();
          if (playerName.includes(lowerCaseKeyword)) {
            score += 5; // Highest weight for player's name
          }
          if (year.startsWith(lowerCaseKeyword)) {
            score += 3; // Next highest weight for year
          }
          if (cardName.includes(lowerCaseKeyword)) {
            score += 2; // Weight for card name
          }
          if (variation.includes(lowerCaseKeyword)) {
            score += 2; // Weight for variation
          }
          if (numberBehind.startsWith("#" + lowerCaseKeyword)) {
            score += 5; // Highest weight for specific format in numberBehind
          }
        });
      }
      return { ...card, score };
    });

    // Only include cards with a score greater than 0 if there's an active search term
    const relevantCards = activeSearchTerm
      ? cardsWithMatchCount.filter((card) => card.score > 0)
      : cardsWithMatchCount;

    // Sort by match count if there's a non-empty active search term
    const sortedCards = relevantCards.sort((a, b) => b.score - a.score);

    // Apply other filters
    const filteredCards = sortedCards.filter((card) => {
      return filterBy.every(([key, value]) => {
        if (key === "SearchTitle") return true; // Skip SearchTitle since it's handled by matchCount

        if (key === "minPrice") {
          return (
            value === "" || parseFloat(card.EstimateValue) >= parseFloat(value)
          );
        }

        if (key === "maxPrice") {
          return (
            value === "" || parseFloat(card.EstimateValue) <= parseFloat(value)
          );
        }

        if (key === "Attribut") {
          const checkedValues = Object.entries(value)
            .filter(([_, v]) => v)
            .map(([k]) => k);
          const attributeMatches = checkedValues.map((attr) => {
            switch (attr) {
              case "IsRookie":
                return card.IsRookie === "Rookie(RC)";
              case "IsAuto":
                return card.IsAuto !== "NotAuto";
              case "IsPatch":
                return card.IsPatch !== "NotPatch";
              case "IsJersey":
                return card.IsJersey !== "NotJersey";
              default:
                return false;
            }
          });
          return attributeFilterLogic === "Or"
            ? attributeMatches.some(Boolean)
            : attributeMatches.every(Boolean);
        }

        if (key === "GroupBy") {
          const checkedValues = Object.entries(value)
            .filter(([_, v]) => v)
            .map(([k]) => k);
          const groupMatches = checkedValues.map((attr) => {
            switch (attr) {
              case "isPC":
                return card.isPC === "isPC";
              case "isOnEbay":
                return card.isOnEbay === "isOnEbay";
              case "isForTrade":
                return card.isForTrade === "isForTrade";
              case "isForSale":
                return card.isForSale === "isForSale";
              default:
                return false;
            }
          });
          return isWhatFilterLogic === "Or"
            ? groupMatches.some(Boolean)
            : groupMatches.every(Boolean);
        }

        // Handling for other filters
        const checkedValues = Object.entries(value)
          .filter(([_, v]) => v)
          .map(([k]) => k);
        return checkedValues.includes(String(card[key]));
      });
    });

    // Further filtering if within a specific collection
    let finalFilteredCards = filteredCards;
    if (
      selectedCollectionLive &&
      selectedCollectionLive !== "" &&
      selectedCollectionLive !== 0
    ) {
      finalFilteredCards = filteredCards.filter((card) =>
        selectedCollectionCards.some(
          (collectionCard) =>
            parseInt(card.id) === parseInt(collectionCard.userCardId)
        )
      );
    }

    setFilteredCards(finalFilteredCards);
    setOriginalData(finalFilteredCards);
    // Step 1: Retrieve unique IDs
  const uniqueIds = new Set(finalFilteredCards.map(card => card.CardId));
  console.log('uniqueIds',uniqueIds)
  console.log('groupedCards',groupedCards)
  const filteredGrouped = new Map([...groupedCards].filter(([key, value]) => uniqueIds.has(value.CardId)));
  console.log('filteredGrouped',filteredGrouped)
  setFilteredGroupedCards(filteredGrouped)
  console.log('AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA filteredGrouped',filteredGrouped)
   

    setCurrentPage(1);
    const totalValue = finalFilteredCards.reduce(
      (sum, card) => sum + parseFloat(card.EstimateValue),
      0
    );
    const totalLength = finalFilteredCards.length;

    setTotalCardLenght(totalLength);
    setTotalCardValue(totalValue);
  }, [
    cards,
    filterValues,
    activeSearchTerm,
    selectedCollectionCards,
    selectedCollectionLive,
    attributeFilterLogic,
    isWhatFilterLogic,
    triggerFilterChange,
    viewAsGrid,
  ]);

  //--------------------------------------------End of useEffect for filters---------------------------------------------------

  function filterCardBySelectedCollection(selectedListId) {
    setTempoCards(cards);

    const filteredData = allCollectionCards.filter(
      (item) => parseInt(item.ListId) === parseInt(selectedListId)
    );

    setSelectedCollectionCards(filteredData);
    console.log("setSelectedColelction 289", filteredData);
    console.log("allcollectioncards 291", allCollectionCards);
    setIsViewCollection(true);
  }

  function resetFilters() {
    // Uncheck all checkboxes
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    // Clear all text inputs
    const inputs = document.querySelectorAll('input[type="text"]');
    inputs.forEach((input) => {
      input.value = "";
    });
    console.log("checkedbox", checkedCheckboxes);
    setCheckedCheckboxes({});
    setFilterValues({});
  }
  //-----------------------------------------------End Of Filters + Prepare rendering---------------------------------------------------

  //-----------------------------------------------Counts for filters---------------------------------------------------

  useEffect(() => {
    const counts = {
      Name: {},
      SetName: {},
      TeamsId: {},
      YearMade: {},
      cardName: {},
      variationName: {},
      IsRookie: {},
      IsPatch: {},
      IsJersey: {},
      IsAuto: {},
      isForSale: {},
      isPC: {},
      isForTrade: {},
      isOnEbay: {},
      isGone: {},
      Graded: {},
      GradeCompany: {},
      Grade: {},
    };

    filteredCards.forEach((card) => {
      Object.keys(counts).forEach((key) => {
        if (!counts[key][card[key]]) {
          counts[key][card[key]] = 0;
        }
        counts[key][card[key]]++;
      });
    });

    setNameCounts(counts.Name);
    setSetCounts(counts.SetName);
    setTeamsIdCounts(counts.TeamsId);
    setCardNameCounts(counts.cardName);
    setVariationNameCounts(counts.variationName);
    setYearCounts(counts.YearMade);
    setIsRookieCounts(counts.IsRookie);
    setIsPatchCounts(counts.IsPatch);
    setIsJerseyCounts(counts.IsJersey);
    setIsAutoCounts(counts.IsAuto);
    setIsForSaleCounts(counts.isForSale);
    setIsPCCounts(counts.isPC);
    setIsForTradeCounts(counts.isForTrade);
    setIsOnEbayCounts(counts.isOnEbay);
    setIsGoneCounts(counts.isGone);
    setIsGradedCounts(counts.Graded);
    setGradeCompanyCounts(counts.GradeCompany);
    setGradeCounts(counts.Grade);
  }, [filteredCards]);

  //-----------------------------------------------End Of Counts for filters---------------------------------------------------

  //-----------------------------------------------Handle---------------------------------------------------
  const handleFilterChange = (event) => {
    const { name, value, checked } = event.target;

    console.log("name, value, checked ", name, value, checked);

    console.log("checkcheckedboxlist", checkedCheckboxes);
    console.log("filtervalues", filterValues);
    /*  
   if (name === "isGone") {
        setIsGoneChecked((prevState) => ({
          ...prevState,
          [name]: checked ? true : false,
        }));
      }
    */
    if (name === "isGraded") {
      setFilterValues((prevState) => ({
        ...prevState,
        [name]: checked ? true : null,
      }));
    } else {
      // Update the checked checkboxes state
      setCheckedCheckboxes((prevState) => ({
        ...prevState,
        [value]: !checkedCheckboxes[value],
      }));
      // Handle checkbox change in category filters
      setFilterValues((prevState) => {
        const updatedFilters = { ...prevState[name] };

        if (checked) {
          updatedFilters[value] = true;
        } else {
          // If unchecked, remove the filter
          delete updatedFilters[value];
          // Check if the category is now empty, and if so, remove the category
          if (Object.keys(updatedFilters).length === 0) {
            const updatedState = { ...prevState };
            delete updatedState[name];
            return updatedState;
          }
        }

        return {
          ...prevState,
          [name]: updatedFilters,
        };
      });
    }
  };
  function handleClickSearchButton(isItBlank) {
    if (!isItBlank) {
      setActiveSearchTerm(searchTermInput);
      updateFilterSearchBar(
        "SearchBar",
        searchTermInput,
        searchTermInput.length > 0 ? true : false
      );
    } else {
      setActiveSearchTerm("");
    }
  }

  const updateFilterSearchBar = (name, value, isChecked) => {
    if (name === "SearchBar" && value != "") {
      setFilterValues((prevState) => {
        const updatedFilters = { [value]: true };
        return {
          ...prevState,
          [name]: updatedFilters,
        };
      });
    }
  };

  // This function abstracts the core logic for updating filters
  const updateFilterValues = (name, value, isChecked) => {
    // Logic to update filter values based on provided parameters
    // Similar to your existing handleFilterChange logic
    console.log("1 name, value, isChecked", name, value, isChecked);
    if (["IsAuto", "IsPatch", "IsJersey", "IsRookie"].includes(name)) {
      console.log("name inside iswhat", name);
      name = "Attribut";
    }
    if (["isPC", "isOnEbay", "isForTrade", "isForSale"].includes(name)) {
      console.log("name inside isfor", name);
      name = "GroupBy";
    }
    if (["Graded", "Raw"].includes(name)) {
      console.log("name inside isfor", name);
      if (value === "Yes") {
        value = "Graded";
      }
      name = "Graded";
    }

    console.log("2 name, value, isChecked", name, value, isChecked);
    setCheckedCheckboxes((prevState) => ({
      ...prevState,
      [value]: isChecked,
    }));

    setFilterValues((prevState) => {
      const updatedFilters = { ...prevState[name] };

      if (isChecked) {
        updatedFilters[value] = true;
      } else {
        delete updatedFilters[value];
        if (Object.keys(updatedFilters).length === 0) {
          const updatedState = { ...prevState };
          delete updatedState[name];
          return updatedState;
        }
      }

      return {
        ...prevState,
        [name]: updatedFilters,
      };
    });
  };

  // Adjusted handleFilterChange to use the abstracted logic
  // const handleFilterChange = (event) => {
  //   const { name, value, checked } = event.target;
  //   updateFilterValues(name, value, checked);
  // };

  // // New handler for button presses
  const handleButtonFilterChange = (name, value) => {
    // Here, value is the filter value, and we toggle based on current state
    const isChecked = !checkedCheckboxes[value];
    updateFilterValues(name, value, isChecked);
  };

  const handleSearchFilterChange = (event) => {
    const { name, value, checked } = event.target;

    // Access the selected option element
    const selectedOption = event.target.options[event.target.selectedIndex];

    // Access the 'name' attribute of the selected option
    const optionName = selectedOption.getAttribute("name");

    console.log("value : ", value);
    console.log(optionName);

    // Update the checked checkboxes state
    setCheckedCheckboxes((prevState) => ({
      ...prevState,
      [value]: true,
    }));

    // Handle checkbox change in other categories
    setFilterValues((prevState) => {
      const updatedFilters = { ...prevState[optionName] };
      updatedFilters[value] = true;

      return {
        ...prevState,
        [optionName]: updatedFilters,
      };
    });
    //}
  };

  const removeFilter = (category, filter) => {
    const updatedFilters = { ...filterValues };
    const updatedCheckedCheckboxes = { ...checkedCheckboxes };

    // Remove the filter from the category in filterValues
    delete updatedFilters[category][filter];
    console.log("category,filter", [category], [filter]);
    // Remove the filter from the category in checkedCheckboxes
    setCheckedCheckboxes((prevState) => ({
      ...prevState,
      [filter]: !checkedCheckboxes[filter],
    }));

    // If the category is empty in filterValues, remove the entire category
    if (Object.keys(updatedFilters[category]).length === 0) {
      delete updatedFilters[category];
    }

    // If the category is empty in checkedCheckboxes, remove the entire category
    setFilterValues(updatedFilters);
    if (category === "SearchBar") {
      setSearchTermInput("");
      handleClickSearchButton(true);
    }

    console.log("Removed filter:", filter, "from category:", category);

    // Uncheck the checkbox corresponding to the filter
    /* const checkbox = document.querySelector(`input[type="checkbox"][name="${category}"][value="${filter}"]`);
    if (checkbox) {
      checkbox.checked = false;
    }*/

    // Clear the input field corresponding to the filter
    const inputField = document.querySelector(
      `input[type="text"][id="${filter}"]`
    );
    if (inputField) {
      inputField.value = "";
    }
  };

  // Function to clear all filters in a category
  const clearCategory = (category) => {
    const updatedFilters = { ...filterValues };
    console.log("update ", updatedFilters[category]);

    const updatedCheckedCheckboxes = { ...checkedCheckboxes };
    console.log("checkbox", updatedCheckedCheckboxes);

    // Iterate through the keys (names) in updatedCheckedCheckboxes
    for (const key in updatedCheckedCheckboxes) {
      if (
        updatedFilters.hasOwnProperty(category) &&
        updatedFilters[category].hasOwnProperty(key)
      ) {
        console.log(true, "key : ", key, "category : ", category);
        // If the key matches the category, delete it from the updatedCheckedCheckboxes
        delete updatedCheckedCheckboxes[key];
      } else {
        console.log(false, "key : ", key, "category : ", category);
      }
    }

    delete updatedFilters[category];
    setFilterValues(updatedFilters);
    // Update the checkedCheckboxes state with the modified object
    setCheckedCheckboxes(updatedCheckedCheckboxes);

    const checkboxes = document.querySelectorAll(
      `input[type="checkbox"][name="${category}"]`
    );
    console.log("checkechk", checkboxes);
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    // Clear input fields associated with the category name
    const inputFields = document.querySelectorAll(
      `input[type="text"][id="${category}"]`
    );
    inputFields.forEach((input) => {
      input.value = "";
    });
  };

  const handleCardClick = async (card, ifFromCheckBox) => {
    console.log("ifFromCheckBox", ifFromCheckBox);
    if (multiEditState) {
      // Add or remove the card ID from selectedCards based on its presence
      await setSelectedCards((prevSelectedCards) => {
        const isSelected = prevSelectedCards.includes(card.id);
        if (isSelected) {
          if (
            prevSelectedCards.includes(card.id) &&
            selectedCards.length === 1 &&
            ifFromCheckBox
          )
            setMultiEditState(false);
          return prevSelectedCards.filter((id) => id !== card.id);
        } else {
          console.log(selectedCards);
          return [...prevSelectedCards, card.id];
        }
      });
    } else {
      if (selectedCards.length === 0 && ifFromCheckBox) {
        setMultiEditState(true);
        setSelectedCards((prevSelectedCards) => {
          return [card.id];
        });
      } else {
        setSelectedCard(card);
        navigate(`/cards/${card.id}`, {
          state: { card: card, viewAsGrid: viewAsGrid },
        });
      }
    }
  };

  const getSelectedCards = () => {
    return selectedCards;
  };

  function handleChangeCollectionLive(
    listIdProvided,
    listTitleProvided,
    innerText
  ) {
    setSelectedCollectionLive(listIdProvided);
    setSelectedCollectionTitle(listTitleProvided);
    console.log("listTitleProvided ", listTitleProvided);
    console.log("listIdProvided", listIdProvided);
    console.log("innerText", innerText);
    setSelectedCollectionInnerText(innerText);
    // Perform any other necessary actions or validations

    console.log("listidprovided : ", listIdProvided);
    if (listIdProvided && listIdProvided !== "") {
      // Filter cards based on the selected collection
      filterCardBySelectedCollection(listIdProvided);
      setIsViewCollection(true);
      setSelectedCards([]);
    } else {
      // Reset the filter and show all cards
      setSelectedCollectionCards([]);
      setIsViewCollection(false);
      setFilteredCards(cards);
      resetFilters();
      setSelectedCards([]);
    }
  }

  function handleCancelCreateCollection() {
    setConfirmationVisibleCreateNewCollection(false);
    setCreateNewCollectionTitle("");
    setSelectedAction1("Select Action null");
  }

  function handleAssignToCollectionCancelButtonClick() {
    setSelectedAction1("Select Action null");
  }

  function handleCancelRenameCollection() {
    setConfirmationVisibleRenameWatchList(false);
    // setCreateNewCollectionTitle('');
  }
  //-----------------------------------------------HandleUpdateStatusChange---------------------------------------------------
  const handleUpdateStatusChange = (event) => {
    const { name, checked } = event.target;

    switch (name) {
      case "isPcUpdate":
        setIsPcUpdate(checked);
        break;
      case "isForSaleUpdate":
        setIsForSaleUpdate(checked);
        break;
      case "isForTradeUpdate":
        setIsForTradeUpdate(checked);
        break;
      case "isOnEbayUpdate":
        setIsOnEbayUpdate(checked);
        break;
      default:
        break;
    }
  };

  //-------------------HandleUpdateStatusButtonClick
  const handleUpdateStatusCancelButtonClick = () => {
    setIsForSaleUpdate(false);
    setIsForTradeUpdate(false);
    setIsOnEbayUpdate(false);
    setIsPcUpdate(false);
    setSelectedAction1("Select Action null");
  };
  const handleUpdateStatusButtonClick = () => {
    // Update values in the database
    // Use the state variables (isPcUpdate, isForSaleUpdate, etc.) to send the updated values
    // Call the API endpoint and handle the response
    updateStatusForCards(true);
    // Reset the state variables
    setIsForSaleUpdate(false);
    setIsForTradeUpdate(false);
    setIsOnEbayUpdate(false);
    setIsPcUpdate(false);
    setSelectedAction1("Select Action null");
  };

  //----------------------------------------------Start of Group actions---------------------------------------------------
  const handleMultiEditButton = () => {
    // Perform the group action using the selectedCards array
    if (multiEditState) {
      setMultiEditState(false);
      setSelectedCards([]);
      console.log("set editState a false");
      setSelectedAction1("Select Action null");
    } else {
      setMultiEditState(true);
      console.log("set editState a true");
    }
  };
  //---------------------------------------------- actionAssignToCollection - Display collection choice to assign------------------------------------------------

  function onAssignCollection(CollectionId, cardId) {
    insertSingleIntoCardsCardsList(CollectionId, [cardId]);
    console.log("CollectionId,cardId", CollectionId, cardId);
  }

  function displayCreateCollectionForm() {
    // Render the form elements (dropdown and confirm button)
    const createCollectionLabel = (
      <div>
        <label htmlFor="createCollection">Creating a new collection</label>
      </div>
    );
    const collectionNameInput = (
      <input
        type="text"
        value={createNewCollectionTitle}
        onChange={(e) => setCreateNewCollectionTitle(e.target.value)}
        placeholder="Enter a name for the collection"
      />
    );
    /*handleCreateNewCollection()*/
    const confirmButton = (
      <button onClick={() => handleCreateNewCollection(true)}>Confirm</button>
    );
    const cancelButton = (
      <button onClick={() => handleCancelCreateCollection()}>Cancel</button>
    );
    return (
      <div>
        {createCollectionLabel}
        {collectionNameInput}
        {confirmButton}
        {cancelButton}
      </div>
    );
  }

  function displayRenameCollectionForm() {
    // Render the form elements (dropdown and confirm button)
    const renameCollectionLabel = (
      <div>
        <label htmlFor="renameCollection">Rename this collection</label>
      </div>
    );
    const collectionNameInput = (
      <input
        id="id"
        type="text"
        value={renameCollectionTitle}
        onChange={(e) => setRenameCollectionTitle(e.target.value)}
        placeholder="Enter a new name for this collection"
      />
    );
    /*handleCreateNewCollection()*/
    const confirmButton = (
      <button onClick={() => handleRenameCollection(true)}>Confirm</button>
    );
    const cancelButton = (
      <button onClick={() => handleCancelRenameCollection()}>Cancel</button>
    );
    return (
      <div>
        {renameCollectionLabel}
        {collectionNameInput}
        <div
          style={{
            maxHeight: "55px",
            display: "flex",
            justifyContent: "space-evenly",
          }}
          className="flex-h"
        >
          {confirmButton}
          {cancelButton}
        </div>
      </div>
    );
  }

  function displayAssignToCollectionForm() {
    // Render the form elements (dropdown and confirm button)
    console.log(collections);
    const collectionSelect = (
      <select
        value={selectedCollection}
        onChange={(e) => setSelectedCollection(e.target.value)}
      >
        <option value="">Select a collection</option>
        {/* Populate with existing collections */}
        {collections.map((collection) => (
          <option key={collection.ListId} value={collection.ListId}>
            {`${collection.Title} (${collection.collectionCount})`}
          </option>
        ))}
      </select>
    );

    const confirmButton = (
      <button onClick={handleAssignToCollection}>Confirm</button>
    );
    const cancelButton = (
      <button onClick={() => handleAssignToCollectionCancelButtonClick()}>
        Cancel
      </button>
    );
    return (
      <div>
        {collectionSelect}
        {confirmButton}
        {cancelButton}
      </div>
    );
  }
  //---------------------------------------------- actionUpdateStatus - Display status choice to update------------------------------------------------
  function displayUpdateStatusForm() {
    // Render the form elements (dropdown and confirm button)
    console.log(collections);
    const statusSelectLabel = (
      <label>{`Check the new status for your selected cards (${selectedCards.length}) `}</label>
    );

    const statusSelect = (
      <div>
        <label>Is Pc</label>
        <input
          type="checkbox"
          name="isPcUpdate"
          value={isPcUpdate}
          onChange={handleUpdateStatusChange}
        />
        <label>For Sale</label>
        <input
          type="checkbox"
          name="isForSaleUpdate"
          value={isForSaleUpdate}
          onChange={handleUpdateStatusChange}
        />
        <label>For trade</label>
        <input
          type="checkbox"
          name="isForTradeUpdate"
          value={isForTradeUpdate}
          onChange={handleUpdateStatusChange}
        />
        <label>On ebay</label>
        <input
          type="checkbox"
          name="isOnEbayUpdate"
          value={isOnEbayUpdate}
          onChange={handleUpdateStatusChange}
        />
      </div>
    );

    const confirmButton = (
      <button onClick={() => handleUpdateStatusButtonClick()}>Update</button>
    );
    const cancelButton = (
      <button onClick={() => handleUpdateStatusCancelButtonClick()}>
        Cancel
      </button>
    );
    return (
      <div>
        {statusSelectLabel}
        {statusSelect}
        {confirmButton}
        {cancelButton}
      </div>
    );
  }
  //---------------------------------------------- actionAssignToCollection - Insert into collection------------------------------------------------
  function handleAssignToCollection() {
    console.log("selected en dessous");
    console.log(selectedCollection);
    insertIntoCardsCardsList(selectedCollection);
    setSelectedAction1("");
  }
  //---------------------------------------------- actionChangeStatus - Change status------------------------------------------------
  function performAction3() {
    console.log("Performing Action 3");
    // Add your code for Action 3 here
  }

  function premadeExport() {
    console.log("export");
    console.log("im exporting selectedCards", selectedCards);
    const ExportingCards = selectedCards;
    navigate(`/MainExport`, {
      state: {
        userCardIds: ExportingCards,
        userId: userId,
      },
    });
  }

  //---------------------------------------------- Groupe actions - Handle------------------------------------------------
  function handleGroupAction(event) {
    const selectedAction = event.target.value;
    setSelectedAction1(selectedAction);
    event.target.selectedIndex = 0;
    // Execute the associated function based on the selected action
    switch (selectedAction) {
      case "actionAssignToCollection":
        //  AssignToCollection();
        displayAssignToCollectionForm();
        break;
      case "actionCreateNewCollection":
        displayCreateCollectionForm();
        break;
      case "actionChangeStatus":
        performAction3();
        break;
      case "export":
        premadeExport();

      case "actionDeleteFromCollection":
        //removeFromCardsCardsList(selectedCollectionLive);
        setConfirmationVisibleForDeleteFromCollectionOnly(true);
        break;
      case "actionDeleteFromAll":
        setConfirmationVisibleForDeleteCards(true);
        break;
      default:
        // Handle default case or do nothing
        break;
    }
    console.log("Selected cards:", selectedCards);
    console.log(selectedAction);
    console.log(confirmationVisibleForDeleteFromCollectionOnly);
  }

  //----------------------------------------------End of Group actions---------------------------------------------------
  //----------------------------------------------End of Handle---------------------------------------------------

  //----------------------------------------------Start of Filter Unique---------------------------------------------------
  let uniqueNames = [];
  let uniqueSets = [];
  let uniqueTeamsId = [];
  let uniqueCardName = [];
  let uniqueVariationName = [];
  let uniqueYear = [];
  let uniqueIsRookie = [];
  let uniqueIsPatch = [];
  let uniqueIsJersey = [];
  let uniqueIsAuto = [];
  let uniqueIsForSale = [];
  let uniqueIsPC = [];
  let uniqueIsForTrade = [];
  let uniqueIsOnEbay = [];
  let uniqueIsGone = [];
  let uniqueIsGraded = [];
  let uniqueGradeCompany = [];
  let uniqueGrade = [];

  if (cards.length > 0) {
    uniqueNames = [...new Set(cards.map((card) => card.Name))].sort();
    uniqueSets = [...new Set(cards.map((card) => card.SetName))].sort();
    uniqueTeamsId = [...new Set(cards.map((card) => card.TeamsId))].sort();
    uniqueCardName = [...new Set(cards.map((card) => card.cardName))].sort();
    uniqueVariationName = [
      ...new Set(cards.map((card) => card.variationName)),
    ].sort();
    uniqueYear = [...new Set(cards.map((card) => card.YearMade))].sort();
    uniqueIsRookie = [...new Set(cards.map((card) => card.IsRookie))].sort();
    uniqueIsPatch = [...new Set(cards.map((card) => card.IsPatch))].sort();
    uniqueIsJersey = [...new Set(cards.map((card) => card.IsJersey))].sort();
    uniqueIsAuto = [...new Set(cards.map((card) => card.IsAuto))].sort();
    uniqueIsForSale = [...new Set(cards.map((card) => card.isForSale))].sort();
    uniqueIsPC = [...new Set(cards.map((card) => card.isPC))].sort();
    uniqueIsForTrade = [
      ...new Set(cards.map((card) => card.isForTrade)),
    ].sort();
    uniqueIsOnEbay = [...new Set(cards.map((card) => card.isOnEbay))].sort();
    uniqueIsGone = [...new Set(cards.map((card) => card.isGone))].sort();
    uniqueIsGraded = [...new Set(cards.map((card) => card.Graded))].sort();
    uniqueGradeCompany = [...new Set(cards.map((card) => card.GradeCompany))]
      .filter((gradeCompany) => gradeCompany !== "")
      .sort();
    uniqueGrade = [...new Set(cards.map((card) => card.Grade))]
      .filter((grade) => grade !== 0)
      .sort();
  } else {
    // Handle the case when cards is empty or null
    console.error("Error: cards is empty or null");
  }

  //----------------------------------------------End of Filter Unique---------------------------------------------------
  //Filter Order by

  const FilterGroup = ({
    title,
    items,
    counts,
    checkedCheckboxes,
    handleFilterChange,
  }) => {
    // Create two arrays: one for checked items and one for unchecked items
    let checkedItems = [];
    let uncheckedItems = [];
    const [isListOpen, setIsListOpen] = useState(true);
    const [showMoreFilter, setShowMoreFilter] = useState(false);
    // Fonction pour basculer l'état de la liste
    const toggleList = () => {
      setIsListOpen(!isListOpen);
    };
    const toggleShowMoreFilter = () => {
      setShowMoreFilter(!showMoreFilter);
    };
    if (items.length > 0) {
      checkedItems = items.filter((item) => checkedCheckboxes[item]);
      uncheckedItems = items.filter((item) => !checkedCheckboxes[item]);

      // Sort both arrays by counts
      checkedItems.sort((a, b) => counts[b] - counts[a]);
      uncheckedItems.sort((a, b) => counts[b] - counts[a]);
    }

    function FindTheTeamNameById(teamId) {
      const team = teams[teamId];
      return team ? team.name : "Unknown Team";
    }
    const handleAttributeToggle = (attribut) => {
      console.log("handleAttributeToggle", attribut);
    };

    const modifyLabel = (label) => {
      if (label === "NotisPC") {
        return "NotPC";
      } else if (label === "isPC") {
        return "PC";
      } else if (label === "NotisOnEbay") {
        return "NotOnEbay";
      } else if (label === "isOnEbay") {
        return "OnEbay";
      } else if (label === "NotisForTrade") {
        return "NotForTrade";
      } else if (label === "isForTrade") {
        return "ForTrade";
      } else if (label === "NotisForSale") {
        return "NotForSale";
      } else if (label === "isForSale") {
        return "ForSale";
      } else if (label === "Name") {
        return "Player";
      } else if (label === "TeamsId") {
        return "Team(Uniform)";
      } else if (label === "SetName") {
        return "Set";
      } else if (label === "cardName") {
        return "Card";
      } else if (label === "variationName") {
        return "Variation";
      } else if (label === "YearMade") {
        return "Year";
      } else if (label === "IsAuto") {
        return "Auto";
      } else if (label === "IsRookie") {
        return "Rookie";
      } else if (label === "IsPatch") {
        return "Patch";
      } else if (label === "IsJersey") {
        return "Jersey";
      } else if (label === "IsAuto") {
        return "Auto";
      } else if (label === "GradeCompany") {
        return "GradingCompany";
      } else {
        return label;
      }
    };

    ////////////
    const renderGradedButtons = () => {
      // Define your attributes in groups
      const firstGroupAttributes = [["Graded"], ["Raw"]];
      // , ['IsTribute', 'Tribute']

      // Function to render buttons for a given group of attributes
      const renderButtonsForGroup = (attributes) =>
        attributes.map((attribute) => (
          <button
            key={attribute[0]}
            className={`toggle-button ${
              checkedCheckboxes[attribute[0]] ? "active" : ""
            }`}
            onClick={() => handleButtonFilterChange(attribute[0], attribute[0])} // Adjusting method to toggle attributes
          >
            {modifyLabel(attribute[0])}
          </button>
        ));

      return (
        <>
          <div className="flex-h">
            {renderButtonsForGroup(firstGroupAttributes)}
          </div>
        </>
      );
    };

    //////////
    const renderAttributeButtons = () => {
      // Define your attributes in groups
      const firstGroupAttributes = [
        ["IsRookie", "Rookie(RC)"],
        ["IsPatch", "Patch"],
      ];
      const secondGroupAttributes = [
        ["IsJersey", "Jersey"],
        ["IsAuto", "Auto"],
      ];
      // , ['IsTribute', 'Tribute']

      // Function to render buttons for a given group of attributes
      const renderButtonsForGroup = (attributes) =>
        attributes.map((attribute) => (
          <button
            key={attribute[0]}
            className={`toggle-button ${
              checkedCheckboxes[attribute[0]] ? "active" : ""
            }`}
            onClick={() => handleButtonFilterChange(attribute[0], attribute[0])} // Adjusting method to toggle attributes
          >
            {modifyLabel(attribute[0])}
          </button>
        ));

      return (
        <>
          <div className="flex-h">
            {renderButtonsForGroup(firstGroupAttributes)}
          </div>
          <div className="flex-h">
            {renderButtonsForGroup(secondGroupAttributes)}
          </div>
        </>
      );
    };

    const renderIsWhatButtons = () => {
      // Define your attributes in groups
      const firstGroupIsWhat = [
        ["isForSale", "isForSale"],
        ["isForTrade", "isForTrade"],
      ];
      const secondGroupIsWhat = [
        ["isOnEbay", "isOnEbay"],
        ["isPC", "isPC"],
      ];

      // Function to render buttons for a given group of attributes
      const renderButtonsForGroup = (IsWhats) =>
        IsWhats.map((IsWhat) => (
          <button
            key={IsWhat[0]}
            className={`toggle-button ${
              checkedCheckboxes[IsWhat[0]] ? "active" : ""
            }`}
            onClick={() => handleButtonFilterChange(IsWhat[0], IsWhat[0])} // Adjusting method to toggle attributes
          >
            {modifyLabel(IsWhat[0])}
          </button>
        ));

      return (
        <>
          <div className="flex-h">
            {renderButtonsForGroup(firstGroupIsWhat)}
          </div>
          <div className="flex-h">
            {renderButtonsForGroup(secondGroupIsWhat)}
          </div>
        </>
      );
    };

    return (
      <div className="filter-group">
        <div className="title" onClick={toggleList}>
          <h5>{title === "isGone" ? "RecentlyDeleted" : modifyLabel(title)}</h5>
          <svg
            className={isListOpen ? "icon open" : "icon"}
            viewBox="0 0 7 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.5 -6.11959e-07L6.53109 3.75L0.468912 3.75L3.5 -6.11959e-07Z"
              fill="#F5DAFF"
            />
          </svg>
        </div>
        <div className="list open">
          {checkedItems.map((item, index) => (
            <div
              className={
                index >= 5 && !showMoreFilter ? "checkb hidden" : "checkb"
              }
              key={item}
            >
              {/* Ensure this is not the 'Filter Attribut' section to avoid duplicating the condition */}
              {title !== "Filter Attribut" && title !== "Filter Graded" && (
                <>
                  <input
                    type="checkbox"
                    name={title}
                    value={item}
                    checked={checkedCheckboxes[item] || false}
                    onChange={handleFilterChange}
                  />
                  <label>
                    {title === "TeamsId"
                      ? FindTheTeamNameById(item)
                      : modifyLabel(item)}
                  </label>
                  <p style={{ marginLeft: "5px", color: "black" }}>
                    ({counts[item] || 0})
                  </p>
                </>
              )}
            </div>
          ))}

          {checkedItems.length > 5 && (
            <button
              onClick={() => toggleShowMoreFilter()}
              style={{ marginTop: "10px" }}
            >
              {showMoreFilter ? "Less" : "More"}
            </button>
          )}
        </div>

        <div className={isListOpen ? "list open" : "list"}>
          {title === "Filter Attribut" && (
            <div>
              {" "}
              <AttributeFilterToggle
                currentLogic={attributeFilterLogic}
                setLogic={setAttributeFilterLogic}
              />
              <div>{renderAttributeButtons()}</div>
            </div>
          )}

          {title === "GroupBy" && (
            <div>
              {" "}
              <AttributeFilterToggle
                currentLogic={isWhatFilterLogic}
                setLogic={setIsWhatFilterLogic}
              />
              <div>{renderIsWhatButtons()}</div>
            </div>
          )}

          {title === "Filter Graded" && (
            <div>
              {" "}
              <div>{renderGradedButtons()}</div>
            </div>
          )}

          {uncheckedItems.map((item, index) => (
            <div
              className={
                index >= 5 && !showMoreFilter ? "checkb hidden" : "checkb"
              }
              key={item}
            >
              {title !== "Filter Attribut" &&
                title !== "GroupBy" &&
                title !== "Filter Graded" && (
                  <>
                    <input
                      type="checkbox"
                      name={title}
                      value={item}
                      checked={checkedCheckboxes[item] || false}
                      onChange={handleFilterChange}
                    />
                    <label>
                      {title === "TeamsId"
                        ? FindTheTeamNameById(item)
                        : modifyLabel(item)}
                    </label>
                    <p style={{ marginLeft: "5px", color: "lightgray" }}>
                      ({counts[item] || 0})
                    </p>
                  </>
                )}
            </div>
          ))}
          {uncheckedItems.length > 5 && (
            <button
              onClick={() => toggleShowMoreFilter()}
              style={{ marginTop: "10px" }}
            >
              {showMoreFilter ? "Less" : "More"}
            </button>
          )}
        </div>
      </div>
    );
  };

  //-----------------------------------Test
  function deleteCardsFromAll(confirmationIs) {
    let cardIds = [...selectedCards];
    if (singleCardOperationId !== 0) cardIds = [singleCardOperationId];
    console.log("CardIds to delete", cardIds);
    const handleUserResponse = (response) => {
      if (response) {
        // Perform the delete user account operation
        // ...
        fetch("https://projet-collect-v1-production.up.railway.app/api/remove/card", {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ cardIds }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log(data.message); // Assuming the API returns a success message
            // Perform additional actions after deleting the cards
            // ...
            setSingleCardOperationId(0);
          })
          .catch((error) => {
            console.error("Error deleting cards:", error);
          });
        console.log("Cards deleted");
      } else {
        console.log("Delete operation canceled by the user");
      }

      setConfirmationVisibleForDeleteCards(false);
    };

    handleUserResponse(confirmationIs);
  }

  //----------------------Delete watchlist and cards_watchlist

  function deleteCollection(isConfirmed) {
    if (isConfirmed) {
      const requestData = {
        listId: selectedCollectionLive,
        UserId: userId,
      };
      // Handle user's response
      console.log("This is it", selectedCollectionLive, userId);
      fetch("https://projet-collect-v1-production.up.railway.app/api/collection/remove/thisWatchList", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      })
        .then((response) => response.json())
        .then(() => {
          console.log("Collection Deleted");
          fetchCollectionsCards();
          fetchCollections();
          setNeedToReset(!needToReset);
        })
        .catch((error) => {
          console.error("Error deleting this collection", error);
        });
      setConfirmationVisibleDeleteCollection(false);
    }
  }
  let currentCard;
  function handleSingleCardEditClick(card) {
    console.log(card);
    navigate(`/EditCard/${card.id}`, {
      state: { card },
    });

    nextOperation("Edit");
  }

  function handleSingleCardDeleteClick(userCardId) {
    setSingleCardOperationId(userCardId);
    nextOperation("DeleteFromAll");
  }

  function handleSingleCardRemoveFromWatchlistClick(userCardId) {
    setSingleCardOperationId(userCardId);
    nextOperation("DeleteFromWatchlist");
  }

  function nextOperation(operation) {
    switch (operation) {
      case "Edit":
        console.log("Editing...");
        break;
      case "DeleteFromAll":
        setConfirmationVisibleForDeleteCards(true);
        console.log("Deleting...");
        break;
      case "DeleteFromWatchlist":
        setConfirmationVisibleForDeleteFromCollectionOnly(true);
        console.log("Removing from watchlist...");
        break;
      default:
        console.log("Invalid operation");
        break;
    }
  }

  const AttributeFilterToggle = ({ currentLogic, setLogic }) => {
    // Determine checkbox states based on current logic
    const isOrChecked = currentLogic === "Or";
    const isAndChecked = currentLogic === "And";

    // Handle logic change
    const handleLogicChange = (logic) => {
      setLogic(logic);
    };

    return (
      <div className="logic-option flex-h">
        <label htmlFor="orLogic">Or</label>
        <input
          type="checkbox"
          id="orLogic"
          checked={isOrChecked}
          onChange={() => handleLogicChange("Or")}
          disabled={isOrChecked} // Disable checkbox if already selected
        />

        <label htmlFor="andLogic">And</label>
        <input
          type="checkbox"
          id="andLogic"
          checked={isAndChecked}
          onChange={() => handleLogicChange("And")}
          disabled={isAndChecked} // Disable checkbox if already selected
        />
      </div>
    );
  };

  function isValidStringForDeleteCollection(str) {
    return str !== "";
  }

  //-----------------------------------EndTest
  //----------------------------------------------RenderJSX---------------------------------------------------
  if (!userId) navigate(`/login`);
  else
    return (
      <>
        <div className="sousmenu">
          <button
            className={!selectedCollectionLive ? "active" : ""}
            onClick={() => handleChangeCollectionLive("", "", "")}
          >
            Show all cards
          </button>
          {collections.map((collection) => (
            <button
              className={
                selectedCollectionLive === collection.ListId ? "active" : ""
              }
              onClick={() =>
                handleChangeCollectionLive(
                  collection.ListId,
                  collection.Title,
                  `${collection.Title} (${collection.collectionCount})`
                )
              }
            >{`${collection.Title} (${collection.collectionCount}) `}</button>
          ))}
        </div>
        <div className="card-container">
          {isFilterVisible && (
            <div className="filter-container">
              <div className="card-grid-container">
                {/* <select
                value={selectedCollectionLive}
                onChange={(e) =>
                  handleChangeCollectionLive(
                    e.target.value,
                    e.target.options[e.target.selectedIndex].getAttribute('data-key'),
                    e.target.options[e.target.selectedIndex].innerText
                  )
                }
              >
                <option value="">Show All Cards </option>

                {collections.map((collection) => (
                  <option key={collection.Title} value={collection.ListId} data-key={collection.Title}>
                    {`${collection.Title} (${collection.collectionCount})`}
                  </option>
                ))}
              </select> */}
                {viewOnly ? null : (
                  <>
                    <div className="flex-h">
                      {isValidStringForDeleteCollection(
                        selectedCollectionLive
                      ) &&
                        confirmationVisibleRenameWatchList === false &&
                        confirmationVisibleDeleteCollection === false && (
                          <button
                            onClick={() =>
                              setConfirmationVisibleRenameWatchList(true)
                            }
                          >
                            Rename
                          </button>
                        )}
                      {confirmationVisibleRenameWatchList &&
                        displayRenameCollectionForm()}

                      {isValidStringForDeleteCollection(
                        selectedCollectionLive
                      ) &&
                        confirmationVisibleRenameWatchList === false &&
                        confirmationVisibleDeleteCollection === false && (
                          <button
                            onClick={() =>
                              setConfirmationVisibleDeleteCollection(true)
                            }
                          >
                            Delete watchlist
                          </button>
                        )}

                      <ConfirmationModal
                        isVisible={confirmationVisibleDeleteCollection}
                        onCancel={() =>
                          setConfirmationVisibleDeleteCollection(false)
                        }
                        onConfirm={() => deleteCollection(true)}
                        message={`Are you sure you want to delete this watchlist : "${selectedCollectionInnerText}"?`}
                      />
                    </div>
                  </>
                )}

                <h3 className="nb">
                  {" "}
                  current Result <b>({totalCardLenght})</b>
                </h3>
                {viewOnly ? null : (
                  <>
                    {" "}
                    <p className="nb">
                      Total Card Value: {totalCardValue.toFixed(2)} $
                    </p>
                  </>
                )}
                <div className="flex-h">
                  <button className="btn-simple" onClick={resetFilters}>
                    Reset Filter
                  </button>
                  <button
                    className={
                      !multiEditState ? "btn-simple" : "btn-simple active"
                    }
                    onClick={handleMultiEditButton}
                  >
                    {!multiEditState
                      ? "GroupSelection"
                      : `UndoSelection (${selectedCards.length})`}
                  </button>
                </div>
                {viewOnly ? null : (
                  <>
                    {" "}
                    {multiEditState ? (
                      <select
                        onChange={handleGroupAction}
                        disabled={!multiEditState || selectedCards.length === 0}
                      >
                        <option value="">
                          Select an action for the selected cards
                        </option>
                        <option value="actionAssignToCollection">
                          Assign to an existing collection
                        </option>
                        <option value="actionCreateNewCollection">
                          Create a new collection
                        </option>
                        <option value="actionChangeStatus">
                          Change the status (PC-ForTrade-ForSale)
                        </option>
                        <option value="export">Export those cards</option>
                        {isViewCollection && (
                          <option value="actionDeleteFromCollection">
                            {" "}
                            {`Delete those cards '(${selectedCards.length})' from this collection '${selectedCollectionTitle}' only`}
                          </option>
                        )}
                        <option value="nothing"> </option>
                        <option value="actionDeleteFromAll">{`Delete those cards '(${selectedCards.length})' from your entire portfolio.`}</option>
                      </select>
                    ) : null}
                  </>
                )}

                {viewOnly ? null : (
                  <>
                    <div>
                      {/* Other JSX code */}

                      <ConfirmationModal
                        isVisible={confirmationVisibleForDeleteCards}
                        onCancel={() =>
                          setConfirmationVisibleForDeleteCards(false)
                        }
                        onConfirm={() => deleteCardsFromAll(true)}
                        message={`Are you sure you want to delete your selected cards(${
                          singleCardOperationId !== 0 ? 1 : selectedCards.length
                        }) from this portfolio?`}
                      />

                      {/* Other JSX code */}

                      {/* Use the confirmation modal for the "Delete Card" action */}
                      <ConfirmationModal
                        isVisible={
                          confirmationVisibleForDeleteFromCollectionOnly
                        }
                        onCancel={() =>
                          setConfirmationVisibleForDeleteFromCollectionOnly(
                            false
                          )
                        }
                        onConfirm={() => removeFromCardsCardsList(true)}
                        message={`Are you sure you want to delete the selected cards from the collection: ${selectedCollectionTitle} you are removing (${
                          singleCardOperationId !== 0 ? 1 : selectedCards.length
                        }) cards?`}
                      />
                    </div>
                  </>
                )}
                {/*Confirmation dialog end*/}
                {/* Render the form elements conditionally */}

                {viewOnly ? null : (
                  <>
                    {selectedAction1 === "actionCreateNewCollection" &&
                      multiEditState &&
                      displayCreateCollectionForm()}
                    {selectedAction1 === "actionAssignToCollection" &&
                      multiEditState &&
                      displayAssignToCollectionForm()}
                    {selectedAction1 === "actionChangeStatus" &&
                      multiEditState &&
                      displayUpdateStatusForm()}
                  </>
                )}

                <div className="filters-container">
                  <div className="filter-group">
                    {/* <h2>Name</h2> <NameSelect uniqueNames={uniqueNames} selectedName={searchBarSelectName} setSelectedName={setSearchBarSelectName} handleSearchFilterChange={handleSearchFilterChange} Name={'Name'} /> */}
                    <FilterGroup
                      title="GroupBy"
                      items={uniqueIsRookie}
                      counts={isRookieCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />
                    <FilterGroup
                      title="Filter Attribut"
                      items={uniqueIsRookie}
                      counts={isRookieCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />
                    <FilterGroup
                      title="Filter Graded"
                      items={uniqueIsGraded}
                      counts={isGradedCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />

                    <FilterGroup
                      title="Name"
                      items={uniqueNames}
                      counts={nameCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />
                    <FilterGroup
                      title="TeamsId"
                      items={uniqueTeamsId}
                      counts={teamsIdCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />

                    <FilterGroup
                      title="SetName"
                      items={uniqueSets}
                      counts={setCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />

                    <FilterGroup
                      title="cardName"
                      items={uniqueCardName}
                      counts={cardNameCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />

                    <FilterGroup
                      title="variationName"
                      items={uniqueVariationName}
                      counts={variationNameCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />

                    <FilterGroup
                      title="YearMade"
                      items={uniqueYear}
                      counts={yearCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />

                    {/* <FilterGroup
                      title="IsRookie"
                      items={uniqueIsRookie}
                      counts={isRookieCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />

                    <FilterGroup
                      title="IsPatch"
                      items={uniqueIsPatch}
                      counts={isPatchCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />

                    <FilterGroup
                      title="IsJersey"
                      items={uniqueIsJersey}
                      counts={isJerseyCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />

                    <FilterGroup
                      title="IsAuto"
                      items={uniqueIsAuto}
                      counts={isAutoCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />

                    <FilterGroup
                      title="Graded"
                      items={uniqueIsGraded}
                      counts={isGradedCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    /> */}

                    <FilterGroup
                      title="GradeCompany"
                      items={uniqueGradeCompany}
                      counts={gradeCompanyCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />

                    <FilterGroup
                      title="Grade"
                      items={uniqueGrade}
                      counts={gradeCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />

                    <div className="filter-group filterprix">
                      {" "}
                      <div className="title">
                        {" "}
                        <h2>Price Filter</h2>
                      </div>
                      <div className="flex">
                        <div className="prix">
                          <label htmlFor="minPriceInput">Min Price:</label>
                          <input
                            className="mid"
                            type="number"
                            id="minPriceInput"
                            value={
                              filterValues.minPrice !== 0
                                ? filterValues.minPrice
                                : 0
                            }
                            onChange={(e) =>
                              setFilterValues({
                                ...filterValues,
                                minPrice: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="prix">
                          <label htmlFor="maxPriceInput">Max Price:</label>
                          <input
                            className="mid"
                            type="number"
                            id="maxPriceInput"
                            value={
                              filterValues.maxPrice !== 999999999
                                ? filterValues.maxPrice
                                : ""
                            }
                            onChange={(e) =>
                              setFilterValues({
                                ...filterValues,
                                maxPrice: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                    {/* <FilterGroup
                      title="isPC"
                      items={uniqueIsPC}
                      counts={isPCCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />

                    <FilterGroup
                      title="isForSale"
                      items={uniqueIsForSale}
                      counts={isForSaleCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />
                    <FilterGroup
                      title="isForTrade"
                      items={uniqueIsForTrade}
                      counts={isForTradeCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />

                    <FilterGroup
                      title="isOnEbay"
                      items={uniqueIsOnEbay}
                      counts={isOnEbayCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    /> */}

                    <FilterGroup
                      title="isGone"
                      items={uniqueIsGone}
                      counts={isGoneCounts}
                      checkedCheckboxes={checkedCheckboxes}
                      handleFilterChange={handleFilterChange}
                    />
                  </div>
                </div>

                <div>
                  <h2>-----Group Action -------</h2>
                </div>

                {/* Render the form elements conditionally */}
                {/*Confirmation dialog*/}

                {/*confirmationVisibleForDeleteFromCollectionOnly && (
        <div className="confirmation-modal">
          <p>
            {selectedCollectionLive === ''
              ? "Are you sure you want to delete the selected cards from your entire collection?"
              : `Are you sure you want to delete the selected cards from the collection: ${selectedCollectionTitle} (${selectedCards.length})?`}
          </p>
          <button onClick={() => removeFromCardsCardsList(true)}>Yes</button>
          <button onClick={() => removeFromCardsCardsList(false)}>No</button>
 </div>)*/}

                {/* Render the form elements conditionally */}
                {/*Confirmation dialog*/}
              </div>
            </div>
          )}

          <div
            className={`collection-container ${
              isFilterVisible ? "with-filter" : ""
            }`}
          >
            <div>
              {/* Render FilterComponent and pass the removeFilter function */}

              <FilterComponent
                filterValues={filterValues}
                removeFilter={removeFilter}
                clearCategory={clearCategory}
              />
            </div>

            {!viewAsGrid ? (
              <>
                <PaginationComponent
                  totalPages={totalPages}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  partialOnly={false}
                />

                <SortingSelect
                  data={filteredCards}
                  setData={setFilteredCards}
                  isGrouped={false}
                  originalData={originalData}
                  //bringBackOriginal={()=>setBringBackOriginal(!bringBackOriginal)}
                />
              </>
            ) : (
              <>
                <PaginationComponent
                  totalPages={totalPagesGrouped}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  partialOnly={false}
                />
                <SortingSelect
                  data={filteredGroupedCards}
                  setData={setFilteredGroupedCards}
                  isGrouped={true}
                />{" "}
              </>
            )}

            <div>
              <input
                placeholder="Search"
                value={searchTermInput}
                onChange={(e) => setSearchTermInput(e.target.value)}
              />
              <button onClick={() => handleClickSearchButton(false)}>
                Search
              </button>
            </div>
            <div style={{ alignItems: "center" }} className="flex-h">
              {iconViewImageOnly()}
              {viewImageOnly && iconViewPrice()}
              {isEditingPriceVisible ? (
                <button onClick={() => setIsEditingPriceVisible(false)}>
                  enable EditPrice
                </button>
              ) : (
                <button onClick={() => setIsEditingPriceVisible(true)}>
                  Disable EditPrice
                </button>
              )}
            </div>

            <div
              className={
                !multiEditState
                  ? "card-grid-wrapper"
                  : `card-grid-wrapper multi`
              }
            >
              {!viewAsGrid
                ? //? filteredCards.map((card) => (
                  //  <cardDesign card={card}/>
                  currentItems.map((card) => (
                    <div className="cardcontent">
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        {!viewImageOnly && !viewOnly ? (
                          <>
                            <EditOptionButton
                              handleEdit={() => handleSingleCardEditClick(card)}
                            />

                            <CheckOptions
                              setMultiEditState={setMultiEditState}
                              isItChecked={selectedCards.includes(card.id)}
                              handleCardClick={() =>
                                handleCardClick(card, true)
                              }
                              cardId={card.id}
                            />

                            <MoreOptionsButton
                              onEditClick={() =>
                                handleSingleCardEditClick(card)
                              }
                              onDeleteClick={() =>
                                handleSingleCardDeleteClick(card.id)
                              }
                              onRemoveFromWatchlistClick={() =>
                                handleSingleCardRemoveFromWatchlistClick(
                                  card.id
                                )
                              }
                              onMylisting={selectedCollectionTitle}
                              collectionList={collections}
                              onAssignCollection={onAssignCollection}
                              cardId={card.id}
                            />
                          </>
                        ) : null}
                      </div>
                      <div
                        key={card.id}
                        className={`card ${
                          selectedCards.includes(card.id) ? "card-selected" : ""
                        }`}
                        onClick={() => handleCardClick(card, false)}
                      >
                        <div className="img">
                          <img className="card-image" src={card.Image} />
                          {!viewImageOnly ? (
                            <>
                              <div className="filter"></div>
                              <div className="card-isWhat">
                                {card.IsRookie === "Rookie(RC)" && (
                                  <div className="patch spe">
                                    <p className="strong">RC</p>
                                  </div>
                                )}

                                {card.Graded === "Graded" ? (
                                  <div className="patch spe">
                                    <p>
                                      {card.GradeCompany} - {card.Grade}
                                    </p>
                                  </div>
                                ) : null}

                                {card.IsPatch === "Patch" && (
                                  <div className="patch">
                                    <p>Patch</p>
                                  </div>
                                )}

                                {card.IsJersey === "Jersey" && (
                                  <div className="patch">
                                    <p>Jersey</p>
                                  </div>
                                )}

                                {card.IsAuto === "Auto" && (
                                  <div className="patch">
                                    <p>Auto</p>
                                  </div>
                                )}
                              </div>
                            </>
                          ) : null}
                        </div>
                        {viewPrice ? (
                          <>
                            <h4 className="card-value">
                              {card.EstimateValue}$
                            </h4>
                          </>
                        ) : null}
                        {!viewImageOnly ? (
                          <>
                            <div className="txt">
                              <div className="justify">
                                <h4 className="card-name">{card.Name}</h4>
                                <p className="card-IDcard ">
                                  #{card.NumberBehind}
                                </p>
                              </div>
                              <p className="card-set">{card.SetName}</p>
                              <div className="flex-h">
                                <p className="card-variation">{`${card.cardName} - ${card.variationName}`}</p>

                                {card.Numbered === "" ||
                                card.Numbered === "0" ? null : (
                                  <p className="card-numbered">
                                    {" "}
                                    / {card.Numbered}{" "}
                                  </p>
                                )}
                              </div>

                              <div className="justify bottom">
                                <h4>{card.EstimateValue}$ </h4>

                                <div className="card-isfor">
                                  {card.isForSale === "isForSale" && (
                                    <div className="patch ">
                                      <p>ForSale</p>
                                    </div>
                                  )}

                                  {card.isPC === "isPC" && (
                                    <div className="patch ">
                                      <p>PC</p>
                                    </div>
                                  )}

                                  {card.isForTrade === "isForTrade" && (
                                    <div className="patch">
                                      <p>ForTrade</p>
                                    </div>
                                  )}

                                  {card.isOnEbay === "isOnEbay" && (
                                    <div className="patch">
                                      <p>OnEbay</p>
                                    </div>
                                  )}
                                </div>
                                <div className="cta">
                                  <p
                                    style={{
                                      fontsize: "14px",
                                      fontweight: "400",
                                    }}
                                  >
                                    Voir
                                  </p>
                                  <svg
                                    width="10"
                                    height="6"
                                    viewBox="0 0 17 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M11.3333 10C11.3333 9.47 11.8525 8.67857 12.3781 8.01429C13.0539 7.15714 13.8614 6.40929 14.7872 5.83857C15.4813 5.41071 16.3228 5 17 5M17 5C16.3228 5 15.4806 4.58928 14.7872 4.16143C13.8614 3.59 13.0539 2.84214 12.3781 1.98643C11.8525 1.32143 11.3333 0.52857 11.3333 -1.41195e-06M17 5L-4.37114e-07 5"
                                      stroke="white"
                                      stroke-width="2"
                                    />
                                  </svg>
                                </div>
                              </div>
                              <div className="card-value">
                                {isEditingPriceVisible && (
                                  <PriceEditChange
                                    card={card}
                                    onPriceUpdate={handlePriceUpdate}
                                  />
                                )}
                              </div>
                            </div>{" "}
                          </>
                        ) : null}
                      </div>
                    </div>
                  ))
                : //[...filteredGroupedCards.values()]
                  // currentItemsGrouped.length > 0 &&
                  // [...currentItemsGrouped]
                  //currentItemsGrouped.length > 0 &&
                  // [...currentItemsGrouped.values()]
                  //[...filteredGroupedCards.values()]
                  Array.isArray(currentItemsGrouped) && currentItemsGrouped.length > 0 &&

                   currentItemsGrouped.map((card) => (
                    //  <cardDesign card={card}/>
                    <div className="cardcontent">
                      <MoreOptionsButton
                        onEditClick={() => handleSingleCardEditClick(card)}
                        onDeleteClick={() =>
                          handleSingleCardDeleteClick(card.id)
                        }
                        onRemoveFromWatchlistClick={() =>
                          handleSingleCardRemoveFromWatchlistClick(card.id)
                        }
                        onMylisting={selectedCollectionTitle}
                      />
                      <div
                        key={card.id}
                        className={`card ${
                          selectedCards.includes(card.id) ? "card-selected" : ""
                        }`}
                        onClick={() => handleCardClick(card, false)}
                      >
                        <div className="img">
                          <img className="card-image" src={card.Image} />
                          <div className="filter"></div>
                          <div className="card-isWhat">
                            {card.IsRookie === "Rookie(RC)" && (
                              <div className="patch spe">
                                <p className="strong">RC</p>
                              </div>
                            )}

                            {card.Graded === "Graded" ? (
                              <div className="patch spe">
                                <p>
                                  {card.GradeCompany} - {card.Grade}
                                </p>
                              </div>
                            ) : null}

                            {card.IsPatch === "Patch" && (
                              <div className="patch">
                                <p>Patch</p>
                              </div>
                            )}

                            {card.IsJersey === "Jersey" && (
                              <div className="patch">
                                <p>Jersey</p>
                              </div>
                            )}

                            {card.IsAuto === "Auto" && (
                              <div className="patch">
                                <p>Auto</p>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="txt">
                          <div className="justify">
                            <p className="card-name">{card.Name}</p>
                            <p className="card-IDcard ">
                              {card.CardId}#{card.NumberBehind}
                            </p>
                          </div>
                          <p className="card-set">{card.SetName}</p>
                          <div className="flex-h">
                            <p className="card-variation">{`${card.cardName} - ${card.variationName}`}</p>

                            {card.Numbered === "" ||
                            card.Numbered === "0" ? null : (
                              <p className="card-numbered">
                                {" "}
                                / {card.Numbered}{" "}
                              </p>
                            )}
                          </div>

                          <div className="justify bottom">
                            <h4 className="card-value">
                              {card.EstimateValue}$
                            </h4>
                            <div className="flex-h">
                              <div className="card-isfor">
                                {card.isForSale === "isForSale" && (
                                  <div className="patch">
                                    <p>ForSale</p>
                                  </div>
                                )}

                                {card.isPC === "isPC" && (
                                  <div className="patch">
                                    <p>PC</p>
                                  </div>
                                )}

                                {card.isForTrade === "isForTrade" && (
                                  <div className="patch">
                                    <p>ForTrade</p>
                                  </div>
                                )}

                                {card.isOnEbay === "isOnEbay" && (
                                  <div className="patch">
                                    <p>OnEbay</p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          {viewAsGrid && (
                            <>
                              <div className="flex-h">
                                <button
                                  style={{ maxHeight: "25px", width: "100%" }}
                                >
                                  Graded ({card.grades.Graded.count}){" "}
                                </button>
                                <button
                                  style={{ maxHeight: "25px", width: "100%" }}
                                >
                                  Raw ({card.grades.Raw.count})
                                </button>
                              </div>
                              <div className="flex-h">
                                {card.grades.Graded.lowestEstimateValue !==
                                Infinity ? (
                                  <div className="from-graded">
                                    <p>
                                      From: $
                                      {card.grades.Graded.lowestEstimateValue.toFixed(
                                        2
                                      )}
                                    </p>
                                  </div>
                                ) : (
                                  <div className="from-graded"></div>
                                )}
                                {card.grades.Raw.lowestEstimateValue !==
                                Infinity ? (
                                  <div className="from-raw">
                                    <p>
                                      From - $
                                      {card.grades.Raw.lowestEstimateValue.toFixed(
                                        2
                                      )}
                                    </p>
                                  </div>
                                ) : (
                                  <div className="from-raw"></div>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
            </div>

            {selectedCard && <CardFullView card={selectedCard} />}
            <div style={{ marginTop: "25px" }}>
              {!viewAsGrid ? (
                <>
                  <PaginationComponent
                    totalPages={totalPages}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    itemsPerPage={itemsPerPage}
                    setItemsPerPage={setItemsPerPage}
                    partialOnly={true}
                  />
                </>
              ) : (
                <>
                  <PaginationComponent
                    totalPages={totalPagesGrouped}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    itemsPerPage={itemsPerPage}
                    setItemsPerPage={setItemsPerPage}
                    partialOnly={true}
                  />
                </>
              )}
            </div>
          </div>
          <button onClick={toggleFilter}>Toggle Filter</button>
          {/* Pagination controls */}
        </div>
      </>
    );
}

export default CardGrid;
